import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { MarketingContainer, SectionHeader } from '@vextura/shell';
import type { ReactNode } from 'react';
import { BEFORE_AFTER } from '../content.js';

/**
 * BeforeAfter — the money slide. Two-column table with the CFO-legible
 * numbers. This is the single highest-converting section on the page
 * because it does the whole sales argument in one glance: same team,
 * same hardware, different numbers.
 */
export function BeforeAfter(): ReactNode {
  return (
    <MarketingContainer paddingY="default">
      <SpaceBetween size="xl">
        <SectionHeader eyebrow="Before / after" headline={BEFORE_AFTER.headline} />
        <Container>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr auto 1fr',
              gap: 0,
              alignItems: 'stretch',
            }}
          >
            <div
              style={{
                padding: '18px 24px',
                fontSize: 12,
                fontWeight: 600,
                letterSpacing: 0.5,
                textTransform: 'uppercase',
                color: '#94a3b8',
                borderBottom: '2px solid #e2e8f0',
              }}
            >
              Before
            </div>
            <div style={{ borderBottom: '2px solid #e2e8f0' }} />
            <div
              style={{
                padding: '18px 24px',
                fontSize: 12,
                fontWeight: 600,
                letterSpacing: 0.5,
                textTransform: 'uppercase',
                color: '#6366f1',
                borderBottom: '2px solid #e2e8f0',
              }}
            >
              After Vextura
            </div>
            {BEFORE_AFTER.rows.map((row, i) => (
              <BeforeAfterRow key={i} row={row} isLast={i === BEFORE_AFTER.rows.length - 1} />
            ))}
          </div>
        </Container>
      </SpaceBetween>
    </MarketingContainer>
  );
}

function BeforeAfterRow({
  row,
  isLast,
}: {
  row: { before: string; after: string };
  isLast: boolean;
}): ReactNode {
  const border = isLast ? '0' : '1px solid #f1f5f9';
  return (
    <>
      <div
        style={{
          padding: '20px 24px',
          borderBottom: border,
          color: '#475569',
          fontSize: 15,
        }}
      >
        {row.before}
      </div>
      <div
        style={{
          padding: '20px 8px',
          borderBottom: border,
          color: '#cbd5e1',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        →
      </div>
      <div
        style={{
          padding: '20px 24px',
          borderBottom: border,
          color: '#0f172a',
          fontSize: 15,
          fontWeight: 600,
        }}
      >
        {row.after}
      </div>
    </>
  );
}
